module.exports = __webpack_public_path__ + "static/ogunjimi-834713df271638f5e6958d0b33a2d763.png";